
<template>
    <el-dialog
      title="返利核算单详情"
      :visible.sync="visible"
      width="850px"
      @close="handleClose">
      <el-form ref="form" label-width="150px">
        <el-row class="form-title">基础信息</el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="返利核算单号">{{form.code}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="返利核算单名称">{{form.name}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="返利产生规则名称">{{form.policyName}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="返利产生规则编码">{{form.policyCode}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="状态">{{form.statusName}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请金额合计（元）">{{form.totalApplyAmount}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="审核金额（元）">{{isEdit ? totalAuditAmount : form.totalAuditAmount}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间">{{form.createTime}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="审核时间">{{form.verifyTime}}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row class="form-title">
        返利明细
        <el-button type="primary" @click="handleExport" class="export-btn" v-permission="'0230202'">导出</el-button>
      </el-row>
      <el-table border :data="detailTable" tooltip-effect="light">
        <el-table-column type="expand">
          <template slot-scope="props" v-if="props.row.relationOrderInfoDtoList && props.row.relationOrderInfoDtoList.length">
            <div v-for="(item, index) in props.row.relationOrderInfoDtoList" :key=index>
              <div class="detailWrap">订单: {{ item.orderNum  }} <span>运发量: {{ item.actualNum }}</span></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="customerName"
          label="客户名称"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="customerLevel"
          label="客户等级"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="itemNames"
          label="商品名称"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="actualNum"
          label="运发量（t）"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="perTonRebate"
          label="每吨返利（元/t）"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="applyAmount"
          label="申请金额（元）"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          label="审核金额（元）"
          width="180"
          >
          <template slot-scope="scope" >
            <el-input-number v-if="isEdit" v-model="scope.row.auditAmount" :step="1"  :precision="2" :min="0"></el-input-number>
            <span v-else>{{scope.row.auditAmount}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listState.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page="listState.pageNo"
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange">
      </el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关 闭</el-button>
        <el-button @click="handleSubmit" v-if="isEdit">保 存</el-button>
      </div>
    </el-dialog>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'addOrEditDialog',
  props: ['show', 'info', 'isEdit'],
  data () {
    return {
      visible: false,
      form: {},
      detailTable: [],
      total: 0,
      listState: {
        pageNo: 1,
        pageSize: 10
      }
    }
  },
  computed: {
    totalAuditAmount () {
      const total = this.detailTable.reduce((sum, item) => sum + item.auditAmount, 0)
      return total
    }
  },
  mounted () {
    this.visible = true
    this.queryDetail()
    this.queryTable()
  },
  methods: {
    ...mapActions(['rebateAuditFormInfoDm', 'rebateAuditFormInfoListDm', 'exportAuditFormDm', 'differentRebateDetailUpdate']),
    handleClose () {
      this.$emit('update:show', false)
    },
    queryDetail () {
      this.rebateAuditFormInfoDm({ id: this.info.id }).then(res => {
        if (res.success) {
          this.form = res.data
        }
      })
    },
    queryTable () {
      const params = {
        ...this.listState,
        rebateAuditFormId: this.info.id
      }
      this.rebateAuditFormInfoListDm(params).then(res => {
        if (res.success) {
          const { list = [], total, pageNum, pageSize } = res.data
          this.detailTable = list
          this.total = total
          this.listState.pageNo = pageNum
          this.listState.pageSize = pageSize
        }
      })
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.listState.pageSize = val
      this.queryTable()
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.listState.pageNo = val
      this.queryTable()
    },
    // 导出
    handleExport () {
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const params = {
          rebateAuditFormId: this.info.id,
          ...this.listState
        }
        this.exportAuditFormDm(params).then((res) => {
          function createDownloadFile () {
            let blob = new Blob([res])
            let link = document.createElement('a')
            link.download = '返利明细.xls'
            link.style.display = 'none'
            link.target = '_Blank'
            link.href = window.URL.createObjectURL(blob)
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(link.href)
          }
          createDownloadFile()
          this.$message.success('导出成功')
        })
      }).catch(() => {})
    },
    handleSubmit () {
      let updateList = this.detailTable.map(item => ({
        id: item.id,
        auditAmount: item.auditAmount
      }))
      this.differentRebateDetailUpdate({ updateList }).then(res => {
        if (res.success) {
          this.$message.success('操作成功')
          this.$emit('update:show', false)
        }
      })
    }
  },
  watch: {
    show (newVal) {
      this.visible = newVal
      if (newVal) {
        // this.form = this.isEdit ? { ...this.info } : this.$lodash.cloneDeep(this.baseForm)
      }
    }
  }
}
</script>
  <style lang="scss" scoped>
  .el-input, .form-select, .el-input-number {
    width: 150px;
  }

  .img-upload {
    height: 148px;
  }
  .form-title {
    font-weight: bold;
    margin-bottom: 20px;
  }
  .export-btn{
    float: right;
  }
  .detailWrap{
    padding-left: 60px;
    height: 25px;
    span{
      margin-left: 187px;
    }
  }
  </style>
